import React from 'react';
import TextField from '@material-ui/core/TextField';

const TaggingField = ({label, file, onChange, onBlur, helperText, title, className}) => {

    return (
        <TextField
            type="text"
            name="tags"
            className={className}
            placeholder={label}
            onChange={onChange}
            onBlur={onBlur}
            value={file.sTags}
            title={title}
            helperText={helperText}
        />
    );
};

export default TaggingField;